import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListCollectionChallengesRequest } from './list-collection-challenges-request';
import type { IListCollectionChallengesResponse } from './list-collection-challenges-response';
import { listCollectionChallengesResponseSchema } from './list-collection-challenges-response';

export async function listCollectionChallengesApi(
  { id }: IListCollectionChallengesRequest,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IListCollectionChallengesResponse>> {
  return getRequest<IListCollectionChallengesResponse>({
    path: `/sys/collections/${id}/challenges`,
    schema: listCollectionChallengesResponseSchema,
    options,
  });
}
